var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83323 1.76398C5.0666 0.939867 6.51664 0.5 8 0.5C9.98913 0.5 11.8968 1.29018 13.3033 2.6967C14.7098 4.10322 15.5 6.01088 15.5 8C15.5 9.48336 15.0601 10.9334 14.236 12.1668C13.4119 13.4001 12.2406 14.3614 10.8701 14.9291C9.49968 15.4968 7.99168 15.6453 6.53683 15.3559C5.08197 15.0665 3.7456 14.3522 2.6967 13.3033C1.64781 12.2544 0.933503 10.918 0.644114 9.46318C0.354725 8.00832 0.50325 6.50032 1.07091 5.12987C1.63856 3.75943 2.59986 2.58809 3.83323 1.76398ZM4.2962 13.5431C5.39253 14.2757 6.68146 14.6667 8 14.6667C9.7675 14.6647 11.462 13.9617 12.7119 12.7119C13.9617 11.462 14.6647 9.7675 14.6667 8C14.6667 6.68146 14.2757 5.39253 13.5431 4.2962C12.8106 3.19987 11.7694 2.34539 10.5512 1.8408C9.33305 1.33622 7.99261 1.2042 6.6994 1.46143C5.4062 1.71867 4.21831 2.3536 3.28596 3.28595C2.35361 4.2183 1.71867 5.40619 1.46144 6.6994C1.2042 7.9926 1.33622 9.33305 1.84081 10.5512C2.34539 11.7694 3.19987 12.8106 4.2962 13.5431ZM8 5.91667C8.46024 5.91667 8.83333 5.54357 8.83333 5.08333C8.83333 4.6231 8.46024 4.25 8 4.25C7.53976 4.25 7.16667 4.6231 7.16667 5.08333C7.16667 5.54357 7.53976 5.91667 8 5.91667ZM8.41667 7.58333V6.75H6.75V7.58333H7.58333V10.9167H6.75V11.75H9.25V10.9167H8.41667V7.58333Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Info_icon.845bc5fcf32bcebceb3b2b040379a525.svg";